import { PageFrame } from "../../components/page_frame";
import { RunReportCardContainer } from "./container";

export const RunReportCardPage = () => {
  return (
    <PageFrame>
      <RunReportCardContainer />
    </PageFrame>
  );
};
